// extracted by mini-css-extract-plugin
module.exports = {"section":"SearchAudioBookList__section","content":"SearchAudioBookList__content"};